'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('acctst', {
      url: '/acctst',
      template: '<acctst></acctst>'
    });
}



// WEBPACK FOOTER //
// ./client/app/accounting/test/acctst.routes.js